const locale = {
  TITLE_PAGE_401: 'Unauthorized',
  SUBTITLE_PAGE_401: 'Oops! You do not have permission to view this page.',
  HOME_BUTTON_PAGE_401: 'Go home',
};

export default locale;
